import React, { useEffect, useState } from "react";
import "../assets/styles/content_section.sass";
import "../assets/styles/static_page.sass";

const StaticPage = ({ page, loading, setLoading }) => {
  if (!page || !page.pageBody) return null;
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        // Construct the path to the content file.
        // This path will now resolve directly to ~/my_proj/www/content/
        const response = await fetch(page.pageBody);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.text();
        setContent(data); // Set the fetched content
      } catch (error) {
        console.error("Failed to fetch content:", error);
        setContent("Error Loading Content");
      } finally {
        setLoading(false); // Set loading to false after fetching (success or failure)
      }
    };

    fetchContent(); // Call the fetch function
  }, [page]);
  return (
    <div className="ur-mini-main ur-mini-static">
      <div
        className="ur-mini-container"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    </div>
  );
};

export default StaticPage;
